import { render } from "./NewsRegist.vue?vue&type=template&id=9e1395d0&scoped=true"
import script from "./NewsRegist.vue?vue&type=script&lang=js"
export * from "./NewsRegist.vue?vue&type=script&lang=js"

import "./NewsRegist.vue?vue&type=style&index=0&id=9e1395d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e1395d0"]])

export default __exports__